import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JobContextService {
  private readonly context$$ = new BehaviorSubject<string>('global');

  get context() {
    return this.context$$.value;
  }

  get context$() {
    return this.context$$;
  }

  set(context: string) {
    this.context$$.next(context);
  }
}
